import { z } from "zod/v4";

z.config({ jitless: true });

export * from "zod/v4";
